//GREEN
export const PRIMARY_GREEN = "#006d33";
export const LIGHT_GREEN = "#F8FAF7";
export const ACTIVE_GREEN = "#6D9E3F";
export const GREEN_OPAQ_20 = "#6D9E3F20";
export const GREEN_OPAQ_15 = "#6D9E3F15";

//BLACK
export const BLACK = "#1F1F1F";

//WHITE
export const WHITE = "#FFFFFF";

//Grey
export const SILVER_GREY = "#DADADA";
export const METALLIC_SILVER = "#BFBFBF";
export const LIGHT_SILVER_GREY = "#E5E5E5";

export const RED = "#DB371F";
export const DARK_GREY = "#898B87";
export const LIGHT_GREY = "#F4F4F4";
export const DAVY_GREY = "#ebebed";

export const PLACEHOLDER_COLOR = "#a2a2a2";

//YELLOw
export const YELLOW = "rgb(186 171 52 / 86%)";

//BLUE
export const BLUE = "#283063"